<template>
	<c-dialog ref="dialog" width="420" @resolve="submitHandle">
		<div class="m-ratio-edit">
			<div class="ratio-field">
				<span class="m-required">*</span>
				<label>控价比例：</label>
				<c-input type="number" decimal="2" :range="[0, 100]" v-model="priceRatio" append-text="%" placeholder="请输入控价比例" style="flex: 1;"></c-input>
			</div>
<!--			<div class="ratio-field">-->
<!--				<span class="m-required">*</span>-->
<!--				<label>控价方式：</label>-->
<!--				<c-radio-group v-model="controlMode" :options="controlModeOptions"></c-radio-group>-->
<!--			</div>-->
<!--			<p class="ratio-desc">控价比例用于测算商品最低售价；低于控价时可正常提交，系统仅作提醒并留痕。选『严格拦截』时，低于控价的商品将不允许提交。</p>-->
		</div>
	</c-dialog>
</template>

<script>
	export default {
		name: 'salePriceRatio',

		data() {
			return {
				priceRatio: '',
				/**低于控价的处置方式（1-严格拦截 2-仅提醒，默认仅提醒）*/
				controlMode: 2,
				controlModeOptions: [{
					name: '仅提醒',
					value: 2
				}, {
					name: '严格拦截',
					value: 1
				}]
			}
		},

		methods: {
			/*********打开弹框（回填当前控价比例与处置方式）**********/
			open(data) {
				this.priceRatio = (data && data.price_ratio !== undefined && data.price_ratio !== null) ? data.price_ratio : '';
				this.controlMode = (data && data.control_mode) || 2;
				this.$refs.dialog.open({
					title: '设置控价比例',
					buttonName: '保存'
				});
			},

			/*********保存控价比例与处置方式**********/
			submitHandle(stop, next) {
				stop();
				var priceRatio = parseFloat(this.priceRatio);
				if (isNaN(priceRatio) || priceRatio < 0) {
					this.$message({message: '请输入控价比例', type: 'warn'});
					return;
				}
				this.request({
					url: '/sale/product/priceRatio/save',
					data: {
						price_ratio: priceRatio
						/**不传 control_mode：服务端约定不传则不覆盖已有处置方式；
						   写死 1 会把未配置过的商户强制落成严格拦截，与控制方式单选已隐藏的口径相悖
						   （未配置或空一律按仅提醒走）*/
					},
					loading: true,
					success: (data, msg) => {
						next();
						this.$message({message: msg || '保存成功', type: 'success'});
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-ratio-edit {
		padding: 24px;

		.ratio-field {
			display: flex;
			align-items: center;
			gap: 8px;

			& + .ratio-field {
				margin-top: 16px;
			}

			label {
				font-size: 14px;
				color: #333;
				white-space: nowrap;
			}
		}

		.m-required {
			color: #e53e3e;
			line-height: 1;
			font-size: 14px;
		}

		.ratio-desc {
			margin-top: 12px;
			font-size: 12px;
			color: #999;
			line-height: 20px;
		}
	}
</style>
